import { AlertSpam, Help, Send, ThumbUp, Waiting } from "@livechat/design-system-icons";

import { TicketPriority, TicketStatus } from "interfaces/entities/ticket";

import { MacroTemplateStrings } from "./helpers";
import { IMacroTemplate } from "./interfaces";

export const ESCALATE_TO_MANAGER_MACRO_TEMPLATE: IMacroTemplate = {
  icon: Waiting,
  premadeType: "ESCALATE",
  agentId: MacroTemplateStrings.CURRENT_AGENT_ID,
  teamIds: null,
  name: "Escalate to manager",
  description:
    "Reassigns the ticket to a manager, sets the priority to urgent, and adds a private note with relevant details for escalation.",
  actions: [
    {
      type: "assign",
    },
    {
      type: "priority",
      priority: TicketPriority.Urgent,
    },
    {
      type: "addFollowers",
      followers: [],
    },
    {
      type: "message",
      isPrivate: true,
      template: {
        text: "This ticket has been escalated to urgent priority and requires immediate attention. Please review the case details and take appropriate action as soon as possible.",
      },
    },
    {
      type: "addTags",
      tagIDs: [],
    },
  ],
};

export const CONFUSED_CUSTOMER_MACRO_TEMPLATE: IMacroTemplate = {
  icon: Help,
  premadeType: "CONFUSED_CUSTOMER",
  agentId: MacroTemplateStrings.CURRENT_AGENT_ID,
  teamIds: null,
  name: "Clarification for customer",
  description:
    "Sends a clear and informative message to the requester, explaining the situation and asking for their understanding.",
  actions: [
    {
      type: "message",
      template: {
        text: "Dear {{ticket.requesterName}},\n\nThank you for contacting us. However, it looks like there might have been a misunderstanding — we aren't the company you were trying to contact and cannot assist with your request.\n\nPlease double-check the contact information of the company you're trying to reach to ensure you connect with the right business.\n\nWe apologize for any inconvenience this may have caused.\n\nBest regards!",
      },
    },
    {
      type: "status",
      status: TicketStatus.Closed,
    },
    {
      type: "addTags",
      tagIDs: [],
    },
  ],
};

export const CUSTOMER_SUPPORT_FOLLOWUP_MACRO_TEMPLATE: IMacroTemplate = {
  icon: Send,
  premadeType: "FOLLOW_UP",
  agentId: MacroTemplateStrings.CURRENT_AGENT_ID,
  teamIds: null,
  name: "Support case follow-up",
  description: "Sends a detailed follow-up message and adds a private note for reference and relevant tags.",
  actions: [
    {
      type: "sendFollowUp",
      template: {
        text: "Hello {{ticket.requesterName}},\n\nWe haven't heard from you for some time, and we wanted to check if you still need assistance. If you require any further help, please reply to this email, and we'll be happy to help.\n\nThank you!\n\nBest regards.",
      },
    },
    {
      type: "message",
      isPrivate: true,
      template: {
        text: "Customer follow-up sent. Please monitor this ticket for a response and escalate if no reply is received within 48 hours.",
      },
    },
    {
      type: "addTags",
      tagIDs: [],
    },
  ],
};

export const FEEDBACK_REQUEST_MACRO_TEMPLATE: IMacroTemplate = {
  icon: ThumbUp,
  premadeType: "FEEDBACK_REQUEST",
  agentId: MacroTemplateStrings.CURRENT_AGENT_ID,
  teamIds: null,
  name: "Customer feedback request",
  description: "Sends a personalized feedback request to gather satisfaction insights.",
  actions: [
    {
      type: "sendRatingRequest",
      template: {
        text: "Hello {{ticket.requesterName}},\n\nWe'd love to hear your thoughts! Your feedback helps us improve and provide better service.\n\nHow would you rate your experience with our support team?\n\nThank you for your time!\n\nBest regards.",
      },
    },
    {
      type: "addTags",
      tagIDs: [],
    },
  ],
};

export const MARK_AS_SPAM_MACRO_TEMPLATE: IMacroTemplate = {
  icon: AlertSpam,
  premadeType: "MARK_AS_SPAM",
  agentId: MacroTemplateStrings.CURRENT_AGENT_ID,
  teamIds: null,
  name: "Mark as spam and close",
  description:
    "Automatically closes the ticket, moves it to the Spam folder, and adds a relevant tag to prevent future issues.",
  actions: [
    {
      type: "status",
      status: TicketStatus.Closed,
    },
    { type: "spam", spam: true },
    {
      type: "addTags",
      tagIDs: [],
    },
  ],
};
